import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";

function TransportationCoordinatorPendingOrder() {
  return (
    <GenericOrdersListing
      title="All Pending Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={true}
      icon={AssignmentRoundedIcon}
      ChatPopup={ChatPopup}
      showAddOrder={false}
      allOrders = {true}
    />
  );
}

export default TransportationCoordinatorPendingOrder;
